import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
var styles = {
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: relative;\n      padding: ", ";\n    "])), t.mobilePopupHeaderPadding);
  },
  rootWithoutContent: function rootWithoutContent() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding: 8px 0 0 0;\n    "])));
  },
  container: function container() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      flex-direction: column;\n    "])));
  },
  caption: function caption(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n    "])), t.mobilePopupHeaderFontSize, t.mobilePopupHeaderLineHeight, t.mobilePopupHeaderFontWeight, t.textColorDefault);
  },
  captionWithChildren: function captionWithChildren() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      padding-bottom: 8px;\n    "])));
  }
};
export var jsStyles = memoizeStyle(styles);